import type { PageLink } from './types'

import { PageTabLink } from './styles'

interface PageMenuProps {
  className?: string
  links: PageLink[]
  saveLastVisitedSubPage?: (to: string) => void
}

export function PageMenu({ className, links, saveLastVisitedSubPage }: PageMenuProps) {
  return (
    <nav className={className}>
      {links.map(({ to, label, LabelWrapperComponent }) => (
        <PageTabLink key={to} to={to} onClick={() => saveLastVisitedSubPage?.(to)}>
          {LabelWrapperComponent ? <LabelWrapperComponent>{label}</LabelWrapperComponent> : label}
        </PageTabLink>
      ))}
    </nav>
  )
}
